import React, { useContext, useState } from "react";
import { Rating, Star, RoundedStar } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";
import { Link } from "react-router-dom";
import { RatingContext } from "./RatingContext";

const starStyle = {
  itemShapes: Star,
  activeFillColor: "#f59e0b", // amber-500
  inactiveFillColor: "#ffedd5", // amber-100
  //   inactiveFillColor: "#999ACF", // amber-100
};

export default function App() {
  //   const [rating, setRating] = useState(0);
  //   const { rating, updateRating } = useContext(RatingContext);

  //   const handleRatingChange = (newRating) => {
  //     updateRating(newRating);
  //     if (newRating >= 4) {
  //       window.open(
  //         "https://chromewebstore.google.com/detail/ihfjboopehfdmedfagockddklomdmglh/reviews",
  //         "_blank"
  //       );
  //     }
  //   };

  return (
    <a
      href="https://chromewebstore.google.com/detail/ihfjboopehfdmedfagockddklomdmglh/reviews"
      className="flex justify-center items-center mt-2 mx-auto text-white rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
    >
      <span className="mr-1">4.8</span>
      <Rating
        readOnly
        value={4.8}
        itemStyles={starStyle}
        style={{ maxWidth: 100 }}
      />
      <span className="ml-1">(23 ratings)</span>
    </a>
  );
}
